module.exports = __webpack_public_path__ + "static/media/koffie.d362e787.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hero/assortiment/koffie.jpg
// module id = 891
// module chunks = 0